import { useMemo } from 'react';

import { FEATURE_FLAG_PLANS_V2 } from '../constants/featureFlags';
import { useGetFeatureAccessQuery } from '../services/billing.api';
import { isToolActive } from '../utils/tariffUtils';

import { useFeatureFlagEnabled } from './useFeatureFlagEnabled';
import { useAppSelector } from './redux';

export const useCanUseTool = (tool?: string) => {
  const isPlansV2Enabled = useFeatureFlagEnabled(FEATURE_FLAG_PLANS_V2);
  const tariffSlice = useAppSelector((s) => s.tariffSlice);
  const isActiveByTariff = useMemo(
    () => (tool ? isToolActive(tool, tariffSlice.current) : false),
    [tariffSlice.current, tool],
  );
  const shouldQuery = isPlansV2Enabled && Boolean(tool);
  const { data, isFetching, isLoading } = useGetFeatureAccessQuery(tool ?? '', {
    skip: !shouldQuery,
  });

  if (!isPlansV2Enabled) {
    return { allowed: isActiveByTariff, remaining: undefined, isLoading: false };
  }

  return {
    allowed: Boolean(data?.access),
    remaining: data?.remaining,
    isLoading: isLoading || isFetching,
  };
};
